module.exports = __webpack_public_path__ + "static/media/flow-sms-es.9c712c24.png";